import { createRouter, createWebHistory } from 'vue-router';

import LinkSolicitante from "@/views/LinkSolicitante"

const routes = [
  {
    path: '/:idAtendimento',
    name: "Link Solicitante",
    component: LinkSolicitante,
    props: true
  },
  // ... outras rotas
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;